import React from 'react'
import {useLocation, useNavigate} from 'react-router-dom';
import Sound from "../Sound/Sound";

function withHooks(WrappedComponent) {
    return function(props) {
        const location = useLocation();
        const navigate = useNavigate();
        return <WrappedComponent location={location} navigate={navigate} {...props}/>
    };
}

class Answerii extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            lang: '',
        };

    }



    render() {
        return (
            <header className="App-header d-grid gap-2">
                <Sound />
            </header>
        );
    }
}

export default withHooks(Answerii)